export const UREEKA_BASEURL = 'https://ureeka.biz/';
export const ZENREG_MKTG_REDIRECT_URL = '/r/register-smb-growth/init/';
export const SMB_MKTG_KICKSTARTER_PRODUCT_CODE = 'smb_mktg_kickstarter_tools_bundle_v1';
export const SMB_MKTG_EFECTIVENESS_PRODUCT_CODE = 'smb_mktg_effectiveness_tools_bundle_v1';
export const SMB_MKTG_KICKSTARTER_REGISTRATION_CODE = 'smbKckStZBv1';
export const SMB_MKTG_EFECTIVENESS_REGISTRATION_CODE = 'smbMktgEffZBv1';
export const VBA_NOTICE_COOKIE = 'virtualAddressNoticeClosed';
export const VBA_ACTIVATION_SHOWN_COOKIE = 'vbaActivationModalShown';
export const PRODUCT_TOUR_COOKIE = 'productTourShowed';
